import React from 'react';
import { rootClsPrefix as clsPrefix } from '../constants';
import sendEnabledIconSvg from '../../assets/images/sendIconEnabled.svg';
import sendDisabledIconSvg from '../../assets/images/sendIconDisabled.svg';
import CapIcon from '../../CapIcon';
import CapImage from '../../CapImage';
import CapInput from '../../CapInput';

const MIN_HEIGHT = '2.5rem';

const baseStyle = {
  display: 'flex',
  alignItems: 'center',
};

const MultiLineInputBox = ({
  value,
  setValue,
  loading,
  placeholder,
  onSubmit,
  style = {},
}) => {
  const onKeyDown = event => {
    const hasNewLine = value.includes('\n');
    if (event.key === 'Enter') {
      if (!hasNewLine && event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        onSubmit();
      }
      else if (hasNewLine && event.key === 'Enter' && event.shiftKey) {
        event.preventDefault();
        onSubmit();
      }
    }
  };
  return (
    <div style={{ width: '100%', ...style }}>
      <div
        className={`${clsPrefix}-multiline-input-root`}
        data-loading={loading.toString()}
      >
        <div className={`${clsPrefix}-inside-input-border`}>
          <div
            style={{ ...baseStyle, height: MIN_HEIGHT, padding: '0 0.5rem' }}
          >
            <CapIcon type="three-star-dark" size="s" />
          </div>
          <div style={{ ...baseStyle, minHeight: MIN_HEIGHT, flexGrow: 1 }}>
            <CapInput.TextArea
              placeholder={placeholder}
              value={value}
              onChange={e => setValue(e.target.value)}
              autosize={{ minRows: 1, maxRows: 10 }}
              className={`${clsPrefix}-text-area`}
              onKeyDown={onKeyDown}
              loading={loading}
            />
          </div>
          <div
            style={{ ...baseStyle, height: MIN_HEIGHT, marginRight: '0.2rem' }}
          >
            {value.trim().length === 0 ? (
              <CapImage src={sendDisabledIconSvg} />
            ) : (
              <CapImage
                src={sendEnabledIconSvg}
                onClick={onSubmit}
                data-testid="send-icon"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiLineInputBox;
